import React, { ReactNode, useState, useEffect, memo } from "react"

export interface iContext {
  isOpen: boolean
  handleOpen: (val: boolean) => void
  toggleDropdown: () => void
}
export interface iDropdownProps {
  children?: ReactNode
  initiallyOpen: boolean
}

export const DropdownContext = React.createContext<iContext>({} as iContext)

const Dropdown: React.FC<iDropdownProps> = ({ children, initiallyOpen }) => {
  const [isOpen, setIsOpen] = useState(initiallyOpen)

  useEffect(() => {
    setIsOpen(initiallyOpen)
  }, [initiallyOpen])

  const handleOpen = (val: boolean): void => {
    setIsOpen(val)
  }

  const toggleDropdown = (): void => {
    setIsOpen(!isOpen)
  }

  return (
    <DropdownContext.Provider value={{ isOpen, handleOpen, toggleDropdown }}>
      {children}
    </DropdownContext.Provider>
  )
}

Dropdown.defaultProps = {
  initiallyOpen: false,
}

export default memo(
  Dropdown,
  (prev, next) => prev.initiallyOpen === next.initiallyOpen,
)
